//Ankita
import React, { useContext, useRef, useEffect, useState } from "react";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import Heading from "../../Components/Heading/Heading";
import { APICall } from "../../Helpers/API/APICalls";
import { APICalls } from "../../Helpers/API/APICalls2";
import {
  InputLabel,
  Select,
  SelectChangeEvent,
  MenuItem,
  FormControl,
} from "@mui/material";

import {
  getEngagementByLeadApi,
  RequirementDownloadExcelTemplate,
  GetDropDownList,
  ReadDatafromExcel,
  getComplexityDropdown,
  getAdditionalReasonDropdown,
  updatestatus,
  updateRequirementTracebility,
  getRequirementTracibilityGrid,
  getRequirementModalPopUp,
  getPhases,
  ExporttoExcelTracibilityRequirement,
} from "../../Helpers/API/APIEndPoints";
import { getContext, LoaderContext } from "../../Helpers/Context/Context";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SelectForm from "../../Components/SelectForm/SelectForm";
import InputForm from "../../Components/InputForm/InputForm";
// import { Tooltip } from "@mui/material";
import { Tooltip } from "antd";
import { LocalizationProvider } from "@mui/x-date-pickers";
import notify from "../../Helpers/ToastNotification";
import fileDownload from "js-file-download";
import "./TraceabilityMatrix.css";
import axios from "axios";
import { Box } from "@mui/material";
// import Modal from "@mui/material/Modal";
import { Card, Form, Modal } from "react-bootstrap";
import uuid from "react-uuid";
import moment from "moment";
function RequirementTraceability() {
  const { EmployeeId, RoleId } = getContext();
  const RoleIdArray = RoleId.split(",");
  let navigate = useNavigate();
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [isAdditionalDisable, setidAdditonalDisable] = useState(false);
  const [requirementid, setID] = useState(0);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [complexity, setComplexity] = useState<any>({});
  const [estimate_Hourswo, setEstimateHourswo] = useState();
  const [estimate_Hours, setEstimateHours] = useState();
  const [isChargable, setisChargable] = useState<any>(true);
  const [disabled, setDisabled] = useState(false);
  const [isChargeablereason, setisChargeableReason] = useState<any>({});
  const [formErrors, setFormErrors] = useState({});
  const [isChargeablereasonDropdown, setisChargeableReasondropdown] = useState(
    []
  );
  const [isAddition, setIsAdditions] = useState(true);
  const [isAdditionalreason, setIsAdditionalreason] = useState<any>({});
  const [isAdditionalreasondropdown, setIsAdditionalreasondropdown] = useState(
    []
  );
  const [complexityDropdown, setComplexitydropdown] = useState<any>([]);
  const [open, setOpen] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [opendeveloped, setOpendeveloped] = useState(false);
  const [openChangeStatus, setOpenChangeStatus] = useState(false);
  const excelFileRef = useRef<any>();
  const [RequirementTraceabilityData, setRequirementTraceabilityData] =
    useState<any>([]);
  const [excelFileName, setExcelFileName] = useState<any>("No File Uploaded");
  const [excelFileContent, setExcelFileContent] = useState<any>("");
  const [Engagement, setEngagement] = useState<any>({});
  const [EngagementOptions, setEngagementOptions] = useState<any>([]);
  const [ModalFormErrors, setModalFormErrors] = useState<any>({});
  const { showLoader, hideLoader } = useContext(LoaderContext); //added by mahesh
  const [aftererr, setAftererror] = useState(0);
  const [isPreUAT, setIsPreUAT] = useState(true);
  let formErrorObj = {};
  let modalFormErrorObj = {};

  const [isPreUATFilter, setIsPreUATFilter] = useState("All"); //Prashant
  const [phasesDropdown, setPhasesDropdown] = useState<any>([]); //prashant
  const [phasesCount, setphasesCount] = useState<any>(0); //Prashant
  const [phases, setphases] = useState<any>({}); //prashant

  // Added custom color for tooltip
  const customColors = ["#2755f3"];

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "title",
      label: "Title",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },

    {
      name: "estimat_Hours_w_o",
      label: "Estimate Hrs (Without Reuse)",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "estimate_Hours",
      label: "Estimate Hrs (With Reuse)",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "requirementStatus",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "isPreUATval",
      label: "IsPreUAT",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
        customBodyRender: (value) => {
          if (value === true) {
            return "Yes";
          } else {
            return "No";
          }
        },
      },
    },
    {
      name: "isActive",
      label: "Active",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          if (value) {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let requirementStatus =
            tableMeta.tableData[tableMeta.rowIndex].requirementStatus;
          let activeStatus = tableMeta.tableData[tableMeta.rowIndex].isActive;
          let id = tableMeta.tableData[tableMeta.rowIndex].id;
          if (requirementStatus != "Developed" && activeStatus == true) {
            return (
              <>
                <Tooltip title="Edit" color={customColors[0]}>
                  <a onClick={() => handleOpen(id)} className="action_icon">
                    <i className="fa fa-pencil" aria-hidden="true"></i>
                  </a>
                </Tooltip>
                <Tooltip title="Developed" color={customColors[0]}>
                  <a
                    onClick={() => handledeveloped(id, "Developed")}
                    className="action_icon"
                  >
                    <i className="fa fa-check-circle" aria-hidden="true"></i>
                  </a>
                </Tooltip>
              </>
            );
          }
          if (!activeStatus) {
            return (
              <>
                <Tooltip title="Edit" color={customColors[0]}>
                  <a onClick={() => handleOpen(id)} className="action_icon">
                    <i className="fa fa-pencil" aria-hidden="true"></i>
                  </a>
                </Tooltip>
              </>
            );
          }
          if (requirementStatus === "Developed") {
            return (
              <>
                <Tooltip title="Edit" color={customColors[0]}>
                  <a onClick={() => handledeveloped(id, "InProgress")}>
                    <i className="fa fa-pencil" aria-hidden="true"></i>
                  </a>
                </Tooltip>
              </>
            );
          }
        },
      },
    },
  ];

  const getPhasesByEngagementId = async () => {
    let obj = {
      EngagementID: Engagement.value,
    };

    const { data } = await APICall(getPhases, "POST", obj);

    if (data != undefined || data != null) {
      let tempArray = [];
      await data.map((phases) => {
        let tempObj = {
          value: phases.id,
          label: phases.reason,
        };
        tempArray.push(tempObj);
      });

      setPhasesDropdown(tempArray);
      setphasesCount(tempArray.length);
    }
  };

  useEffect(() => {
    localStorage.clear(); //deepak gupta
    (async () => {
      await getPhasesByEngagementId();
    })();
  }, [Engagement]);

  useEffect(() => {
    (async () => {
      await getEngagementbyLeads();
    })();
  }, []);

  useEffect(() => {
    (async () => {
      await requirementGrid();
    })();
  }, [
    Engagement,
    start,
    sortColumn,
    sortDirection,
    searchText,
    aftererr,
    isPreUATFilter,
  ]);

  const handleOpen = async (id) => {
    // await complexitydropdown();
    //await additionalreason();
    await requirementModalpopup(id);
    setOpen(true);
  };
  const modalSubmitValidation = async () => {
    modalFormErrorObj = {};
    await setModalFormErrors({});
    if (title === "") {
      setModalFormErrors((preState) => ({
        ...preState,
        ["requirementTitle_isEmpty"]: "Requirement Title can't be empty",
      }));
      modalFormErrorObj["requirementTitle_isEmpty"] =
        "Requirement Title can't be empty";
    }
    if (description === "") {
      setModalFormErrors((preState) => ({
        ...preState,
        ["description_isEmpty"]: "Description Title can't be empty",
      }));
      modalFormErrorObj["description_isEmpty"] =
        "Requirement Title can't be empty";
    }
    if (!isChargable) {
      if (Object.keys(isChargeablereason).length === 0) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["nochargereason_isEmpty"]: "No Charge Reason cannot be empty",
        }));
        modalFormErrorObj["nochargereason_isEmpty"] =
          "No Charge Reason cannot be empty";
      }
    }
    if (!complexity || Object.keys(complexity).length === 0) {
      setModalFormErrors((preState) => ({
        ...preState,
        ["complexity_isEmpty"]: "Complexity  cannot be empty",
      }));
      modalFormErrorObj["complexity_isEmpty"] = "Complexity  cannot be empty";
    }
    if (isAddition) {
      if (Object.keys(isAdditionalreason).length === 0) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["isadditionalReason_isEmpty"]: "Additinal reason  cannot be empty",
        }));
        modalFormErrorObj["isadditionalReason_isEmpty"] =
          "Additinal reason  cannot be empty";
      }
    }

    if (estimate_Hourswo === "") {
      setModalFormErrors((preState) => ({
        ...preState,
        ["estimatehourswo_isEmpty"]: "Estimatehourswo Title can't be empty",
      }));
      modalFormErrorObj["estimatehourswo_isEmpty"] =
        "Estimatehourswo Title can't be empty";
    }

    if (estimate_Hours === "") {
      setModalFormErrors((preState) => ({
        ...preState,
        ["estimatehours_isEmpty"]: "Estimatehours Title can't be empty",
      }));
      modalFormErrorObj["estimatehours_isEmpty"] =
        "Estimatehours Title can't be empty";
    }

    if (phasesCount > 0) {
      if (!phases || Object.keys(phases).length === 0) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["phases_isEmpty"]: "Phases  cannot be empty",
        }));
        modalFormErrorObj["phases_isEmpty"] = "Phases  cannot be empty";
      }
    }
  };

  const handledeveloped = (id, status: any) => {
    if (status === "InProgress") {
      setOpenChangeStatus(true);
    } else {
      setOpendeveloped(true);
    }
    setID(id);
  };

  const handleClose = () => {
    setOpen(false);
    setOpendeveloped(false);
    setOpenChangeStatus(false);
  };

  const getEngagementbyLeads = async () => {
    if (RoleIdArray.includes("3") || RoleIdArray.includes("8")) {
      let postObject = {
        searchFor: "capacityEngagement",
        // searchValue: 3, // commented by mahesh
        searchValue: 1, //added by mahesh
        trace_requiremt: 1, //added by mahesh
      };
      const { data } = await APICall(GetDropDownList, "POST", postObject);

      if (data) {
        let engagementArray = [];

        await data.map((engagement: any) => {
          let tempObj = {
            label: engagement.engagement,
            value: engagement.id,
            //engagementId: engagement.id,
          };
          engagementArray.push(tempObj);
        });

        //  engagementArray.sort((a, b) => a.label.localeCompare(b.label));
        setEngagementOptions(engagementArray);
      }
    } else {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      let postObject = {
        EmployeeID: EmployeeId,
        fromDate: moment(firstDay).format(moment.HTML5_FMT.DATE),
        toDate: moment(lastDay).format(moment.HTML5_FMT.DATE),
      };
      const { data } = await APICall(
        getEngagementByLeadApi,
        "POST",
        postObject
      );

      if (data != undefined || data != null) {
        let engagementArray = [];
        await data.map((eng: any) => {
          let tempObj = {
            value: eng.engagementId,
            label: eng.engagementName,
          };

          engagementArray.push(tempObj);
        });
        setEngagementOptions(engagementArray);
      }
    }
  };

  const handleCheckEvent = async (event, apiFieldName) => {
    if (apiFieldName === "IsChargable") {
      await setisChargable(event.target.checked);
    }

    if (apiFieldName === "isAddition") {
      await setIsAdditions(event.target.checked);
    }

    if (apiFieldName === "isPreUAT") {
      await setIsPreUAT(event.target.checked);
    }
  };

  const complexitydropdown = async () => {
    const { data } = await APICall(getComplexityDropdown, "POST");
    if (data != undefined || data != null) {
      let complexityArray = [];
      data.map((complexitydd: any) => {
        let tempObj = {
          value: complexitydd.id,
          label: complexitydd.complexity,
        };
        complexityArray.push(tempObj);
      });

      setComplexitydropdown(complexityArray);
    }
  };

  const testDropdown = async () => {
    const { data } = await APICall(getComplexityDropdown, "POST");
    if (data) {
      let complexityArray = [];
      data.map((complexitydd: any) => {
        let tempObj = {
          value: complexitydd.id,
          label: complexitydd.complexity,
        };
        complexityArray.push(tempObj);
      });
      setComplexitydropdown(complexityArray);
      return complexityArray;
    }
  };
  const nonchargebaledropdown = async () => {
    let postObject = {
      searchFor: "reason",
      searchValue: 3,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data != undefined || data != null) {
      let tempArray = [];
      await data.map((reasons) => {
        let tempObj = {
          value: reasons.id,
          label: reasons.reason,
        };
        tempArray.push(tempObj);
      });
      setisChargeableReasondropdown(tempArray);
      return tempArray;
    }
  };

  const additionalreason = async () => {
    const { data } = await APICall(getAdditionalReasonDropdown, "POST");
    if (data != undefined || data != null) {
      let additionalArray = [];
      data.map((additional: any) => {
        let tempObj = {
          value: additional.id,
          label: additional.reasons,
        };
        additionalArray.push(tempObj);
      });

      setIsAdditionalreasondropdown(additionalArray);
      return additionalArray;
    }
  };

  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
    customToolbar: () => {
      return (
        <FormControl sx={{ mt: 1 }}>
          <InputLabel id="demo-simple-select-helper-label">IsPreUAT</InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            label="IsPreUAT"
            value={isPreUATFilter}
            onChange={handleChange}
            sx={{
              width: 85,
              height: 30, // Set the desired height
              "&:focus": { color: "success.main" }, // Change text color to green on focus
            }}
          >
            <MenuItem value={"All"}>All</MenuItem>
            <MenuItem value={"active"}>Yes</MenuItem>
            <MenuItem value={"inactive"}>No</MenuItem>
          </Select>
        </FormControl>
      );
    },
  };
  const handleChange = (event: SelectChangeEvent) => {
    setIsPreUATFilter(event.target.value);
  };

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "engagement") {
      setEngagement(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: "Enagagement type cannot be empty",
        }));
      }
    }
    if (apiFieldName === "nochargereason") {
      if (!isChargable) {
        //setDisabled(true);
        setisChargeableReason(event);
        if (event && Object.keys(event).length > 0) {
          setModalFormErrors((preState) => ({
            ...preState,
            ["nochargereason_isEmpty"]: undefined,
          }));
        } else if (!event || Object.keys(event).length === 0) {
          setModalFormErrors((preState) => ({
            ...preState,
            ["nochargereason_isEmpty"]: "No Charge Reason cannot be empty",
          }));
        }
        // setisChargeableReason(event);
      }
    }
    if (apiFieldName === "isadditional") {
      if (isAddition) {
        //setDisabled(true);
        setIsAdditionalreason(event);
        if (event && Object.keys(event).length > 0) {
          setModalFormErrors((preState) => ({
            ...preState,
            ["isadditionalReason_isEmpty"]: undefined,
          }));
        } else if (!event || Object.keys(event).length === 0) {
          setModalFormErrors((preState) => ({
            ...preState,
            ["isadditionalReason_isEmpty"]: "Additional Reason cannot be empty",
          }));
        }
        // setisChargeableReason(event);
      }
    }

    if (apiFieldName === "phases") {
      setphases(event);
      if (event && Object.keys(event).length > 0) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["phases_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["phases_isEmpty"]: "Phases cannot be empty",
        }));
      }
    }

    if (apiFieldName === "complexity") {
      setComplexity(event);
      if (event && Object.keys(event).length > 0) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["complexity_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["complexity_isEmpty"]: "Complexity cannot be empty",
        }));
      }
    }

    if (apiFieldName === "title") {
      setTitle(event.target.value);
      setModalFormErrors((preState) => ({
        ...preState,
        ["requirementTitle_isEmpty"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["requirementTitle_isEmpty"]: "Requirement Title can't be empty",
        }));
      }
    }
    if (apiFieldName === "description") {
      setDescription(event.target.value);
      setModalFormErrors((preState) => ({
        ...preState,
        ["description_isEmpty"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["description_isEmpty"]: "Description  can't be empty",
        }));
      }
    }
    if (apiFieldName === "estimatehourswo") {
      setEstimateHourswo(event.target.value);
      setModalFormErrors((preState) => ({
        ...preState,
        ["estimatehourswo_isEmpty"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["estimatehourswo_isEmpty"]: "Estimatehourswo  can't be empty",
        }));
      }
    }
    if (apiFieldName === "estimatehours") {
      setEstimateHours(event.target.value);
      setModalFormErrors((preState) => ({
        ...preState,
        ["estimatehours_isEmpty"]: "",
      }));
      if (
        event.target.value == undefined ||
        event.target.value == null ||
        event.target.value == ""
      ) {
        setModalFormErrors((preState) => ({
          ...preState,
          ["estimatehours_isEmpty"]: "Estimatehours  can't be empty",
        }));
      }
    }
  };

  const requirementGrid = async () => {
    let requestParams = {
      start: start,
      pageSize: pageSize,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      searchText: searchText,
      EngagementID: Engagement.value,
      IsPreUATStatus: isPreUATFilter,
    };
    const { data } = await APICall(
      getRequirementTracibilityGrid,
      "POST",
      requestParams
    );

    if (data) {
      setRequirementTraceabilityData(data.reuqirementData);
      setCount(data.count);
    }
  };

  const requirementModalpopup = async (id) => {
    let reqstObj = {
      Id: id,
    };
    const { data } = await APICall(getRequirementModalPopUp, "POST", reqstObj);

    let arr = await testDropdown();
    let arr1 = await nonchargebaledropdown();
    let arr2 = await additionalreason();

    setID(id);

    if (data !== null || typeof data !== "string") {
      setTitle(data[0].title);
      setDescription(data[0].description);
      let selectedComplexity = arr.find(
        (res) => res.value === data[0].complexity
      );
      setComplexity(selectedComplexity);
      setComplexitydropdown(arr);
      setEstimateHours(data[0].estimate_Hours);
      setEstimateHourswo(data[0].estimat_Hours_w_o);
      setisChargable(data[0].isChargeable);
      if (data[0].isChargeable == false) {
        let selectedNonChargableReason = arr1.find(
          (res) => res.value === data[0].non_chargeable_Reason
        );
        setisChargeableReason(selectedNonChargableReason);
      }
      setIsAdditions(data[0].isAdditional);
      if (data[0].isAdditional == true) {
        let selectedAdditionalReason = arr2.find(
          (res) => res.value === data[0].additional_reason
        );
        setIsAdditionalreason(selectedAdditionalReason);
      }
      setIsPreUAT(data[0].isPreUATval);
      setIsActive(data[0].isActive);

      if (data[0].phases != null) {
        let obj = {
          EngagementID: Engagement.value,
        };
        const { data } = await APICall(getPhases, "POST", obj);

        let tempArray = [];
        if (data != undefined || data != null) {
          await data.map((phases) => {
            let tempObj = {
              value: phases.id,
              label: phases.phases,
            };
            tempArray.push(tempObj);
          });

          setPhasesDropdown(tempArray);
          setphasesCount(tempArray.length);
        }

        let phase = {};
        phase = tempArray.find((ele) => ele.value === data[0].id);

        setphases(phase);
      } else {
        let obj = {
          EngagementID: Engagement.value,
        };
        const { data } = await APICall(getPhases, "POST", obj);

        if (data != undefined || data != null) {
          let tempArray = [];
          await data.map((phases) => {
            let tempObj = {
              value: phases.id,
              label: phases.phases,
            };
            tempArray.push(tempObj);
          });

          setPhasesDropdown(tempArray);

          setphasesCount(tempArray.length);
        }
      }
    }
  };

  const updateStatus = async (status: any) => {
    let requirementStatus = 0;
    if (status === "ToDeveloped") {
      requirementStatus = 3;
    }
    if (status === "ToInProgress") {
      requirementStatus = 2;
    }
    let obj = {
      Id: requirementid,
      Status: requirementStatus,
    };

    const { data } = await APICall(updatestatus, "POST", obj);
    if (data !== undefined || data != null) {
      notify(0, "Requirement Status Updated Successfully");
      await requirementGrid();
    } else {
      notify(1, "Requirement Status Updation Failed");
    }

    setOpendeveloped(false);
    setOpenChangeStatus(false);
  };

  const UpdateRequirement = async () => {
    showLoader(); //added by mahesh
    await modalSubmitValidation();
    const isEmpty = await Object.values(modalFormErrorObj).every(
      (x) => x === null || x === "" || x == undefined
    );
    if (isEmpty == true) {
      let rqustobj = {
        Id: requirementid,
        Title: title,
        Description: description,
        Complexity: complexity.value,
        Estimat_Hours_w_o: estimate_Hourswo,
        Estimate_Hours: estimate_Hours,
        isChargeable: isChargable,
        Non_chargeable_Reason: isChargable ? 0 : isChargeablereason.value,
        IsAdditional: isAddition,
        Additional_reason: isAddition ? isAdditionalreason.value : 0,
        ISPreUATval: isPreUAT,
        PhasesId: phases ? phases.value : null,
        IsActive: isActive,
      };
      const { data } = await APICall(
        updateRequirementTracebility,
        "POST",
        rqustobj
      );

      if (data !== null || data !== undefined) {
        notify(0, "Requirement Update Successfully");
        (async () => {
          await requirementGrid();
        })();
      } else {
        notify(1, " Update Fail");
      }
      setOpen(false);
    }
    hideLoader(); //added by mahesh
  };

  const RequestExcelFileChange = () => {
    excelFileRef.current.click();
    setExcelFileName(excelFileRef.current.files[0].name);
    if (excelFileRef.current.files[0].name) {
      setFormErrors((preState) => ({
        ...preState,
        ["bulkUploadRequestExcel_isEmpty"]: undefined,
      }));
    } else if (
      excelFileRef.current.files[0].name ||
      excelFileRef.current.files[0].name === "" ||
      excelFileRef.current.files[0].name === "No File Uploaded"
    ) {
      formErrorObj["bulkUploadRequestExcel_isEmpty"] = "please upload file.";
      setFormErrors((preState) => ({
        ...preState,
        ["bulkUploadRequestExcel_isEmpty"]: "Please upload file.",
      }));
    }
  };

  const style = {
    position: "fixed",
    top: "10%",
    left: "10%",
    backgroundColor: "background.paper",
    zIndex: "1000",
    overflowY: "auto",
    width: "80%",
    height: "80%",
    backdrop: "static",
    borderRadius: 3,
    boxShadow: 24,
    p: 4,
  };

  const styles = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 360,
    bgcolor: "background.paper",
    borderRadius: 3,
    boxShadow: 24,
    p: 4,
  };

  const onSubmitValidation = async () => {
    await setFormErrors({});
    formErrorObj = {};
    if (!Engagement || Object.keys(Engagement).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["engagement_isEmpty"]: "Engagement cannot be empty",
      }));
      formErrorObj["engagement_isEmpty"] = "Engagement cannot be empty";
    }

    if (
      !excelFileName ||
      excelFileName === "" ||
      excelFileName === "No File Uploaded"
    ) {
      formErrorObj["bulkUploadRequestExcel_isEmpty"] = "please upload file.";
      setFormErrors(formErrorObj);
    }
  };

  const onClickFunction = async (action: any) => {
    if (action === "submit") {
      setDisabled(true);
      showLoader(); //added by mahesh
      await onSubmitValidation();

      const isEmpty = await Object.values(formErrorObj).every(
        (x) => x === null || x === "" || x == undefined
      );
      if (isEmpty == true) {
        setDisabled(false);
        var formdata = new FormData();

        formdata.append("file", excelFileContent);
        formdata.append("EngagementID", Engagement.value);
        formdata.append(
          "CreatedDate",
          moment(new Date()).format(moment.HTML5_FMT.DATE)
        );
        formdata.append("CreatedBy", EmployeeId);

        const { data } = await APICalls(ReadDatafromExcel, "POST", formdata);
        if (data != undefined || data != null) {
          if (data.responseStatus === 2) {
            var splitted = data.response.split("\n");
            const ErrorList = () => {
              return (
                <ul>
                  {splitted.map((error: string, index) => (
                    <li key={index}>{error}</li>
                  ))}
                </ul>
              );
            };
            notify(1, <ErrorList />);
            setExcelFileName("No File Uploaded");
            setExcelFileContent("");
            await requirementGrid();
          } else {
            notify(0, "Requirements Uploaded Successfully");
            setExcelFileName("No File Uploaded");
            setExcelFileContent("");
            await requirementGrid();
          }
        }
      } else {
        setDisabled(false);
      }
      hideLoader(); //added by mahesh
    } else if (action === "Download") {
      if (!Engagement || Object.keys(Engagement).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: "Engagement cannot be empty",
        }));
        formErrorObj["engagement_isEmpty"] = "Engagement cannot be empty";
      } else {
        axios
          .request({
            responseType: "blob",
            method: "POST",

            //data: Response,
            url: RequirementDownloadExcelTemplate,
            //data:JSON,
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "application/json",
              "Access-Control-Allow-Headers": "*",
            },
            data: {
              EngagementId: Engagement.value,
            },
          })
          .then((response) => {
            fileDownload(response.data, Engagement.label + "Requirements.xlsx");
          })
          .catch((error) => {
            console.log(error.response.data);
          });
      }
    } else if (action == "reset") {
      reset();
    }
  };

  const reset = () => {
    setExcelFileName("No File Uploaded");
    setExcelFileContent("");
    setEngagement({});
  };
  const handleFiles = (e: any) => {
    setExcelFileName(e.target.files[0].name);
    setFormErrors((preState) => ({
      ...preState,
      ["bulkUploadRequestExcel_isEmpty"]: undefined,
    }));
    var f = e.target.files[0];
    setExcelFileContent(f);
    e.target.value = "";
  };

  const ExportToExcel = () => {
    if (!Engagement || !Engagement.value) {
      setFormErrors((prev) => ({
        ...prev,
        engagement_isEmpty: "Engagement type cannot be empty",
      }));
      return; // Stop execution if Engagement is not selected
    } else {
      setFormErrors((prev) => ({
        ...prev,
        engagement_isEmpty: "", // Clear error if valid
      }));
    }
    let obj = {
      EngagementID: Engagement.value,
      IsPreUATStatus: isPreUATFilter,
      sortColumn: sortColumn,
      sortOrder: sortDirection,
      searchText: searchText,
      pageSize: count,
      start,
      count: count,
    };

    axios
      .request({
        responseType: "blob",
        method: "POST",

        url: ExporttoExcelTracibilityRequirement,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        data: obj,
      })
      .then((response) => {
        fileDownload(response.data, "TraceabilityRequirement.xlsx");
      })
      .catch((error) => {});
  };

  return (
    <>
      <Heading title={"Requirement"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Engagement <sup>*</sup>
                {""}
              </label>
              <SelectForm
                options={EngagementOptions}
                placeholder="Select"
                isDisabled={false}
                value={Engagement}
                onChange={(event) => selectOnChange(event, "engagement")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{formErrors["engagement_isEmpty"]}</p>
            </div>
          </div>
          {Object.keys(Engagement).length > 0 && (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Upload Excel <sup>*</sup>
                  </label>
                  <div className="input-group">
                    <div className="custom-file">
                      <input
                        type="file"
                        accept=".xls,.xlsx"
                        className="custom-file-input"
                        id="file"
                        aria-describedby="inputGroupFileAddon01"
                        style={{ borderRadius: "2px" }}
                        onChange={(e) => {
                          handleFiles(e);
                        }}
                      />
                      <label
                        className="custom-file-label"
                        htmlFor="inputGroupFile01"
                      >
                        {excelFileName}
                      </label>
                    </div>
                  </div>
                  <p style={{ color: "red" }}>
                    {formErrors["bulkUploadRequestExcel_isEmpty"]}
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <div className="d-flex gap-2 justify-content-end">
                    {/* <button
                      className="btn btn-export"
                      onClick={() => ExportToExcel()}
                    >
                      Export Excel
                    </button> */}
                    <button
                      className="btn btn-export"
                      onClick={() => onClickFunction("Download")}
                    >
                      Download Template
                    </button>
                    <button
                      className="btn btn-submit"
                      onClick={() => onClickFunction("submit")}
                      disabled={disabled}
                    >
                      Upload
                    </button>
                    <button
                      className="btn btn-reset"
                      onClick={() => onClickFunction("reset")}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="col-lg-12">
            {Engagement && Engagement.value ?
              (<div className="d-flex gap-2 justify-content-end">
                <button
                  className="btn btn-export"
                  onClick={() => ExportToExcel()}
                >
                  Export Excel
                </button>
                </div>
                )
                :
              <></>
            }

          </div>

          <div className="col-lg-12 mt-3">
            <DynamicGrid
              options={options}
              data={RequirementTraceabilityData}
              columns={gridColumns}
            />
          </div>
        </div>
      </div>

      <Modal
        show={open}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        scrollable={true}
        size="lg"
      >
        <Modal.Body>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="form-group">
                <label>
                  Title <sup>*</sup>
                </label>
                <InputForm
                  placeholder={""}
                  isDisabled={false}
                  textArea={false}
                  value={title}
                  onChange={(e) => selectOnChange(e, "title")}
                />
                <p style={{ color: "red" }}>
                  {ModalFormErrors["requirementTitle_isEmpty"]}
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="form-group">
                <label>
                  Complexity <sup>*</sup>
                </label>
                <SelectForm
                  options={complexityDropdown}
                  placeholder="Select"
                  isDisabled={false}
                  value={complexity}
                  onChange={(e) => selectOnChange(e, "complexity")}
                  isMulti={false}
                  noIndicator={false}
                  noSeparator={false}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="form-group">
                <label>
                  Estimate Hrs (Without Reuse) <sup>*</sup>
                </label>
                <InputForm
                  isDisabled={false}
                  placeholder={""}
                  textArea={false}
                  value={estimate_Hourswo}
                  onChange={(e) => selectOnChange(e, "estimatehourswo")}
                />
                <p style={{ color: "red" }}>
                  {ModalFormErrors["estimatehourswo_isEmpty"]}
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="form-group">
                <label>
                  Estimate Hrs(With Reuse) <sup>*</sup>
                </label>
                <InputForm
                  isDisabled={false}
                  placeholder={""}
                  textArea={false}
                  value={estimate_Hours}
                  onChange={(e) => selectOnChange(e, "estimatehours")}
                />
                <p style={{ color: "red" }}>
                  {ModalFormErrors["estimatehours_isEmpty"]}
                </p>
              </div>
            </div>
            {phasesCount == 0 ? null : (
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="form-group">
                  <label>
                    Phases <sup>*</sup>
                  </label>
                  <SelectForm
                    options={phasesDropdown}
                    placeholder="Select"
                    isDisabled={false}
                    value={phases}
                    onChange={(e) => selectOnChange(e, "phases")}
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                  <p style={{ color: "red" }}>
                    {ModalFormErrors["phases_isEmpty"]}
                  </p>
                </div>
              </div>
            )}
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="form-group clearfix">
                <label>Is Chargeable?</label>
                <div>
                  <label style={{ float: "left", marginRight: "5px" }}>
                    No
                  </label>
                  <Form style={{ float: "left" }}>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      label=""
                      onChange={(e) => handleCheckEvent(e, "IsChargable")}
                      checked={isChargable}
                      disabled={false}
                    />
                  </Form>
                  <label style={{ float: "left" }}>Yes</label>
                </div>
              </div>
            </div>
            {!isChargable ? (
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="form-group">
                  <label>
                    Reason, if not chargeable <sup>*</sup>
                  </label>
                  <SelectForm
                    options={isChargeablereasonDropdown}
                    placeholder="Select"
                    isDisabled={false}
                    value={isChargeablereason}
                    onChange={(e) => selectOnChange(e, "nochargereason")}
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                  <p style={{ color: "red" }}>
                    {ModalFormErrors["nochargereason_isEmpty"]}
                  </p>
                </div>
              </div>
            ) : null}
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="form-group clearfix">
                <label>Is Additional?</label>
                <div>
                  <label style={{ float: "left", marginRight: "5px" }}>
                    No
                  </label>
                  <Form style={{ float: "left" }}>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      label=""
                      onChange={(e) => handleCheckEvent(e, "isAddition")}
                      checked={isAddition}
                      disabled={false}
                    />
                  </Form>
                  <label style={{ float: "left" }}>Yes</label>
                </div>
              </div>
            </div>
            {isAddition ? (
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="form-group">
                  <label>
                    Reason, if Additional <sup>*</sup>
                  </label>
                  <SelectForm
                    options={isAdditionalreasondropdown}
                    placeholder="Select"
                    isDisabled={false}
                    value={isAdditionalreason}
                    onChange={(e) => selectOnChange(e, "isadditional")}
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                  <p style={{ color: "red" }}>
                    {ModalFormErrors["isadditionalReason_isEmpty"]}
                  </p>
                </div>
              </div>
            ) : null}
            <div className="col-lg-12">
              <div className="form-group clearfix">
                <label>Is Preuat?</label>
                <div>
                  <label style={{ float: "left", marginRight: "5px" }}>
                    No
                  </label>
                  <Form style={{ float: "left" }}>
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      label=""
                      onChange={(e) => handleCheckEvent(e, "isPreUAT")}
                      checked={isPreUAT}
                      disabled={false}
                    />
                  </Form>
                  <label style={{ float: "left" }}>Yes</label>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-4 col-sm-6">
              <div className="form-group">
                <label>
                  Description <sup>*</sup>
                </label>
                <InputForm
                  placeholder={""}
                  isDisabled={false}
                  textArea={true}
                  value={description}
                  rows={4}
                  onChange={(e) => selectOnChange(e, "description")}
                />
                <p style={{ color: "red" }}>
                  {ModalFormErrors["description_isEmpty"]}
                </p>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="form-group">
                <label htmlFor="isActive" className="mr-2">
                  Is Active
                </label>
                <input
                  id="isActive"
                  type="checkbox"
                  onChange={(e) => setIsActive(e.target.checked)}
                  name="isActive"
                  checked={isActive}
                />
              </div>
            </div>
            <div className="col-lg-12">
              <div className="d-flex justify-content-end gap-2">
                <button
                  type="button"
                  onClick={(e) => handleClose()}
                  className="btn btn-reset"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-submit"
                  onClick={UpdateRequirement}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={opendeveloped}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        size="sm"
      >
        <Modal.Body className="text-center delete_body p-4">
          <i className="fa fa-info mb-3"></i>
          <p className="mb-3">
            Are you sure, you want to change status to developed ?
          </p>
          <div className="d-flex justify-content-center gap-2">
            <button
              type="button"
              onClick={() => handleClose()}
              className="btn btn-reset"
            >
              No
            </button>
            <button
              type="button"
              className="btn btn-delete"
              onClick={(e) => updateStatus("ToDeveloped")}
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={openChangeStatus}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        size="sm"
      >
        <Modal.Body className="text-center delete_body p-4">
          <i className="fa fa-info mb-3"></i>
          <p className="mb-3">
            Are you sure, you want to change status to In Progress?
          </p>
          <div className="d-flex justify-content-center gap-2">
            <button
              type="button"
              onClick={() => handleClose()}
              className="btn btn-reset"
            >
              No
            </button>
            <button
              type="button"
              className="btn btn-delete"
              onClick={(e) => updateStatus("ToInProgress")}
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default RequirementTraceability;
